export default "__VITE_ASSET__O$OEy_Tl__"